import { aboutPoints } from "@/mocks/editorial";
import SectionHeader from "./SectionHeader";

const schema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于瓜爆观察",
  inLanguage: "zh-CN",
  description:
    "瓜爆观察是一个面向中文网民的热点传播观察站，聚焦事件爆发、连锁反应与后续余波的规律分析。",
};

const pillars = [
  { icon: "ri-focus-3-line", title: "现象级拆解", text: "把“爆”还原成看得懂的变量，而不是一句句的感叹。" },
  { icon: "ri-arrow-left-right-line", title: "不站队，只看结构", text: "我们分析立场为何产生，而非替谁站台或煽动对立。" },
  { icon: "ri-database-2-line", title: "事实与观点分开", text: "事实标注来源与不确定，观点明确是分析而非结论。" },
  { icon: "ri-eye-line", title: "送你判断力", text: "不替你思考，而是给你一套反复可用的判断工具。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-100 py-12 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <SectionHeader
              kicker="关于瓜爆观察"
              title="我们为什么做这件事"
              desc="在信息爆炸、情绪易碎的时代，缺的往往不是消息，而是把消息放回结构里看的能力。瓜爆观察想做的，就是那副能帮你理清脉络的“结构眼镜”。"
            />
            <p className="mt-6 text-[15px] leading-relaxed text-foreground-600">
              热点来得快，去得也快。很多人在风波高峰时被情绪裹挟、站队、互撕，等热度散尽才发现，
              真正值得讨论的结构性问题反而没人接着聊。我们决定换个姿势：不追着“今天又爆了什么”，
              而是反复追问“它为什么会爆、波及到谁、留下什么”。把个案放回规律，把热闹还给冷静。
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {aboutPoints.map((p) => (
                <span
                  key={p}
                  className="rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 ring-1 ring-background-200"
                >
                  <i className="ri-check-double-line mr-1 text-primary-600"></i>
                  {p}
                </span>
              ))}
            </div>

            {/* 读者反馈关键词 */}
            <div className="mt-8 rounded-2xl border border-background-200 bg-background-50 p-6">
              <p className="font-medium text-foreground-950">读者常这样形容我们</p>
              <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
                {["条理清晰", "不煽动", "能看懂", "值得收藏"].map((w, i) => (
                  <div
                    key={w}
                    className={`rounded-xl px-3 py-4 text-center ${i % 2 ? "bg-accent-100/70" : "bg-primary-100/60"}`}
                  >
                    <p className="font-heading text-sm font-semibold text-foreground-900">
                      {w}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="flex h-full flex-col gap-4 rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7">
              <p className="font-heading text-lg font-semibold text-foreground-950">
                四条原则，支撑每一次观察
              </p>
              {pillars.map((pillar, i) => (
                <div key={pillar.title} className="flex gap-4 rounded-2xl bg-background-100/70 p-4">
                  <span className="font-heading text-2xl font-semibold text-secondary-300">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-accent-500 text-background-50">
                    <i className={`${pillar.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="font-medium text-foreground-900">{pillar.title}</h4>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                      {pillar.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}